<template>
    <div class="collate">
        <div class='collate-page'>
            <div class="collate-content-top-bar dsp-flex">
                <div class="collate-user-avatar">
                    <div class="my-base-avatar-img" @click="clickAvatar">
                        <img v-bind:src="userData.avatar && userData.avatar != '' ? userData.avatar : 'https://m1.yxdxt.com/d.png'" alt="">
                        <div v-if="parseInt(userVip) != 0" class="avatar-crown"></div>
                        <div v-if="parseInt(userVip) != 0" class="avatar-vip"></div>
                        <div v-if="parseInt(userVip) == 0 && parseInt(userData.donate) == 1" class="avatar-donate"></div>
                    </div>
                </div>
                <div class="collate-top-input-box">
                    <div class="com-search-input">
                        <i class="iconfont icon-search com-i-s"></i>
                        <input class="com-si-input" type="text" placeholder="搜索八字库" :disabled='true' >
                    </div>
                    <div class="search-fake-div" @click.passive="clickSearch"></div>
                </div>
            </div>
            <div class="collate-content">
                <!-- 1. banner部份 -->
                <div class="collate-banner">    
                    <van-swipe class="collate-banner-swipe" :autoplay="3000" indicator-color="white" lazy-render>
                        <van-swipe-item v-for="data in bannerList" :key="data.id" @click="clickBanner(data)">
                            <img :src="data.f_pic" />
                        </van-swipe-item>
                    </van-swipe>
                </div>

                <!-- 2. 顶部菜单栏 -->
                <div class="collate-menu-list dsp-flex">
                    <div class="collate-menu-item" @click="clickMenu(1)">
                        <div class="collate-menu-item-icon collate-menu-item-icon1"></div>
                        <p class="collate-menu-item-p">新手学堂</p>
                    </div>
                    <div class="collate-menu-item" @click="clickMenu(2)">
                        <div class="collate-menu-item-icon collate-menu-item-icon2"></div>
                        <p class="collate-menu-item-p">合盘对比</p>
                    </div>
                    <div class="collate-menu-item" @click="clickMenu(3)">
                        <div class="collate-menu-item-icon collate-menu-item-icon3"></div>
                        <p class="collate-menu-item-p">名人百科</p>
                    </div>
                    <!-- <div class="collate-menu-item" @click="clickMenu(4)">
                        <div class="collate-menu-item-icon collate-menu-item-icon4"></div>
                        <p class="collate-menu-item-p">易学文库</p>
                    </div> -->
                    <div class="collate-menu-item" @click="clickMenu(5)">
                        <div class="collate-menu-item-icon collate-menu-item-icon5"></div>
                        <p class="collate-menu-item-p">六爻起卦</p>
                    </div>
                </div>

                <!-- 3. 排盘输入时间表单 -->
                <collate-form 
                    v-bind:parentNode="parentNode" 
                    v-bind:chooseGroupFunc="clickChooseGroup"
                    v-bind:chooseLabelFunc="clickChooseLabel">
                </collate-form>

                <!-- 4. 每日日历 -->
                <calendar-info-bar></calendar-info-bar>

                <!-- 5. 列表 -->
                <collate-half-content></collate-half-content>

                <!-- 6. 关注二维码 -->
                <!-- <div v-if="CONFIG.platform == 'wechat'" class="collate-note">
                    <img class="collate-note-img" v-bind:src="qrCode" alt="" @click="clickQRCode">
                    <p class="collate-note-p">长按识别二维码关注公众号：天时子平八字</p>
                </div> -->

            </div>
        </div>
        <!-- 底部新增按钮 -->
        <div class="collate-sub-btn-box">
            <!-- <div @click="clickReport" class="collate-sub-btn collate-sub-btn-left"><button></button><span v-if="showYearReportRedCircle" class="red-circle"></span></div> -->
            <!-- <div @click="clickDonate" class="collate-sub-btn collate-sub-btn-right"><button></button></div> -->
        </div>

        <!-- 子路由 -->
        <router-view></router-view>

        <!-- 5. 选择地址组件 -->
        <van-overlay v-show="showArea" @click="clickShowAreaOverlay" />
        <vant-area v-show="showArea"></vant-area>

        <!-- 6. 输入生日日期组件 -->
        <van-popup v-bind:value="showBirthday" position="bottom" @click-overlay="clickShowBirthdayOverlay">
            <input-birthday-panel></input-birthday-panel>
        </van-popup>

        <!-- 7. 年度报告弹框 -->
        <van-popup class="collate-year-report-pop" v-bind:value="showYearReportPop" v-bind:close-on-click-overlay="false">
            <div class="collate-pop-close" @click="clickYearReportClose"><span><i class="iconfont icon-guanbi"></i></span></div>
            <div class="collate-yrp-content">
                <p class="collate-yrp-title">您的八字数据<span class="wd-fire">2025年度报告</span>已准备就绪，马上前往APP客户端生成吧~</p>
                <!-- <p class="collate-yrp-note">如果您是三清宫八字的老用户而且从未导入过历史数据，建议先微信关注公众号『天时子平八字』回复『三清宫』授权导入历史数据记录。</p> -->
            </div>
            <div class="collate-yrp-button-box">
                <button class="button-green collate-yrp-button" @click="checkYearReport">马上查看年报</button>
            </div>
        </van-popup>

        <!-- 8. 友情捐赠弹框 -->
        <van-popup class="collate-donate-pop" v-bind:value="showDonatePop" v-bind:close-on-click-overlay="false">
            <div class="collate-pop-close" @click="clickDonateClose"><span><i class="iconfont icon-guanbi"></i></span></div>
            <div class="collate-yrp-content collate-dp-content">
                <p class="collate-yrp-title">『助力传统文化复兴，我来加油』</p>
                <p>正在火热进行中~</p>
            </div>
            <div class="collate-yrp-button-box">
                <button class="button-green collate-yrp-button" @click="clickDonate">马上参与</button>
            </div>
        </van-popup>

        <!-- 9. 提示浮窗弹框 -->
        <reminder-collate v-if="showCollateReminder"></reminder-collate>

        <!-- 10. 重复八字过滤弹框 -->
        <van-popup v-bind:value="showSamePop" class="layout-same-select-pop-box" @click-overlay="clickSameSelectOverlay">
            <vant-same-select-pop
                v-bind:selectedList="recordSameEightWordList"
                v-bind:itemFunc="clickSameListItem"
                v-bind:saveFunc="clickSameSave">
            </vant-same-select-pop>
        </van-popup>
    </div>
</template>

<script>
import CollateTitleBar from '../layouts/collate/CollateTitleBar.vue'
import CollateForm from '../layouts/collate/CollateForm.vue'
import CollateHalfContent from '../layouts/collate/CollateHalfContent.vue'
import VantArea from '../layouts/vant/VantArea.vue'
import InputBirthdayPanel from '../components/InputBirthdayPanel.vue'
import CalendarInfoBar from '../components/calendar/CalendarInfoBar.vue'
import ReminderCollate from '../layouts/reminder/ReminderCollate.vue'
import VantSameSelectPop from '../layouts/vant/VantSameSelectPop.vue'
import { LS, MIX } from '../modules/utils'
import { ACTIVITY_DOM, DOM } from '../modules/dom'
import { CONFIG } from '../modules/config'
import { SHARE } from '../modules/share'
export default {
    name:  'Collate',
    components: { CollateTitleBar, CollateForm, CollateHalfContent, VantArea, InputBirthdayPanel, CalendarInfoBar, ReminderCollate, VantSameSelectPop},
    computed: {
        userData() {
            return this.$store.state.userData ? this.$store.state.userData.info : {};
        },
        bannerList() {
            return this.$store.state.bannerList;
        },
        gotRecordData() {
            return this.$store.state.record.gotRecordData;
        },
        showSamePop() {
            return this.$store.state.record.showSamePop;
        },
        recordSameEightWordList() {
            return this.$store.state.record.recordSameEightWordList;
        },
        showArea() {
            return this.$store.state.collate.showArea;
        },
        showBirthday() {
            return this.$store.state.collate.showBirthday;
        },
        showCollateReminder() {
            return this.$store.state.reminder.showCollateReminder;
        }
    },
    data(){
        return {
            userVip: 0,
            CONFIG: CONFIG,
            parentNode: {'name': 'Collate'},
            qrCode: require('../assets/images/qrcode.png'),
            bannerUrl: require('../assets/images/banner.png'),
            showYearReportPop: false,
            showYearReportRedCircle: false,
            showDonatePop: false
        }
    },
    mounted: function() {
        // 加载完成后,静默加载全部列表数据
        if(!this.gotRecordData){
            this.$store.dispatch('record/initRecordList');
        }
        // 加载完成后,静默全局的基础数据
        this.$store.dispatch('initBasicData');
        this.$store.dispatch('getHomePageData');
        this.userVip = this.$store.state.userData.info.vip;
        setTimeout(() => {
            this.initDom();
            DOM.showPageByClassName('collate-page');
            SHARE.initConfigShare();
            MIX.trackPageViewed('HomePage');
        }, 100);
        this.$store.state.group.checkedGroup = false;
        setTimeout(() => {
            // this.initDonatePop();
            this.$store.dispatch('reminder/checkCollateExtTime');
            this.$store.dispatch('reminder/checkReportAIStatus');
        }, 2000);
    },
    methods:{
        initDom() {
            var curReportLS = LS.checkCollateYearReportStatus();
            this.showYearReportRedCircle = !curReportLS;
        },
        initDonatePop() {
            var curDonateLS = LS.checkCollateDonatePopStatus();
            this.showDonatePop = !curDonateLS;
            LS.setCollateDonatePopStatus(true);
        },
        clickAvatar() {
            this.$router.replace('/my');
        },
        clickSearch() {
            this.$store.dispatch('search/resetData');
            this.$store.state.search.searchFromPage = 'collate';
            this.$router.replace('/search/collate');
        },
        clickMenu(type) {
            switch(type) {
                case 1:
                    this.$router.replace('/courselist/collate');
                    break;
                case 2:
                    this.$store.state.contrast.contrastFromPage = 'collate';
                    this.$router.replace('/contrastlist/collate');
                    break;
                case 3:
                    this.$router.replace('/famouspedia');
                    break;
                case 4:
                    this.$router.replace('/library/collate');
                    break;
                case 5:
                    // this.$router.replace('/diagram');
                    window.open(CONFIG.ly_url);
                    break;
                default:
                    break;
            }
        },
        clickShowAreaOverlay() {
            this.$store.state.collate.showArea = false;
        },
        clickShowBirthdayOverlay() {
            this.$store.state.collate.showBirthday = false;
            this.$bus.emit('resetIPBPKeyBoard');
        },
        clickChooseGroup() {
            // 非一级页面要用push的方式
            this.$store.state.collate.chooseGroupFromPage = '/collate';
            DOM.hidePageByClassName('collate-page');
            this.$router.replace('/collate/choosegroup');
        },
        clickChooseLabel() {
            this.$store.state.collate.chooseLabelFromPage = '/collate';
            DOM.hidePageByClassName('collate-page');
            this.$router.replace('/collate/label');
        },
        clickDonateClose() {
            LS.setCollateDonatePopStatus(true);
            this.showDonatePop = false;
        },
        clickDonate() {
            LS.setCollateDonatePopStatus(true);
            DOM.showParentPageByClassName('donate-page');
            this.$router.replace('/donate/collate');
        },
        clickYearReportClose() {
            this.showYearReportPop = false;
        },
        clickReport() {
            this.showYearReportPop = true;
            this.showYearReportRedCircle = false;
            LS.setCollateYearReportStatus(true);
        },
        checkYearReport() {
            window.location = CONFIG.download_url;
        },
        clickSameSelectOverlay() {
            this.$store.state.record.showSamePop = false;
        },
        clickSameListItem(data) {
            this.$store.state.record.showSamePop = false;
            var me = this,
                curType = this.$store.state.collate.curStartCollateType,
                personInfo = this.$store.state.record.recordOriginalData[data.id];
            switch(curType) {
                case 'collate':
                    // 打开存在的八字
                    this.$store.dispatch('detail/initDetail', personInfo);
                    this.$store.dispatch('record/updateRecordListData', personInfo);
                    this.$router.replace('/detail/collate/'+ personInfo.id);
                    break;
                case 'report':
                    // 打开存在的测算
                    this.$store.dispatch('detail/initDetail', personInfo);
                    this.$store.dispatch('record/updateRecordListData', personInfo);
                    this.$store.dispatch('report/initReportAIConfig', null);
                    this.$store.state.report.fromPage = 'collate';
                    this.$store.dispatch('report/getReportInfo', {
                        detailInfo: personInfo,
                        cb: function() {
                            // 更新状态
                            var params = {"aitips": 1};
                            me.$store.dispatch('reminder/udpateExtList', {
                                params: params
                            });
                            me.$router.replace('/report/collate/'+personInfo.id);
                        }
                    });
                    break;
                case 'sizhu':
                    // 打开存在的八字
                    this.$store.dispatch('detail/initDetail', personInfo);
                    this.$store.dispatch('record/updateRecordListData', personInfo);
                    this.$router.replace('/detail/collate_advancedcollate/'+ personInfo.id);
                    break;
                default:
                    break;
            }
        },
        clickSameSave() {
            var me = this,
                formData = this.$store.state.collate.formData,
                curType = this.$store.state.collate.curStartCollateType;
            console.log('clickSameSave', formData, curType);
            this.$store.state.record.showSamePop = false;
            switch(curType) {
                case 'collate':
                    // 新建八字
                    this.$store.dispatch('collate/submitCollate', {
                        formData: formData,
                        cb: function(detailId) {
                            me.$router.replace('/detail/collate/'+ detailId);
                        }
                    });
                    break;
                case 'report':
                    // 新建测算
                    this.$store.state.report.fromPage = 'collate';
                    this.$store.dispatch('collate/submitReport', {
                        formData: formData,
                        cb: function(detailId) {
                            me.$router.replace('/report/collate/'+ detailId);
                        }
                    });
                    break;
                case 'year':
                    this.$store.dispatch('collate/submitYear', {
                        formData: formData,
                        cb: function(detailId) {
                            me.$router.replace('/yearcharacter/collate/'+ detailId);
                        }
                    });
                    break;
                case 'sizhu':
                    // 新建四柱起盘八字
                    this.$store.dispatch('collate/submitSiZhuCollate', formData);
                    break;
                default:
                    break;
            }
        },
        clickQRCode() {
            window.location = CONFIG.home_url;
        },
        clickBanner(bData) {
            console.log('clickBanner-----', bData);
            switch(bData.f_type) {
                case 10:   //课程中心
                    this.$router.replace('/courselist/collate');
                    break;
                case 11:   //终身会员活动
                    this.$store.state.activity.showActSixOneEightBtn = false;
                    this.$store.state.activity.showActSixOneEightPop = true;
                    MIX.trackPageViewed('ForeverVip618Page', 'home_banner');
                    break;
                case 13:  //1388弹框
                    this.$store.state.activity.showActAlwaysDiscountPop = true;
                    MIX.trackPageViewed('ForeverVipBannerPage', 'home_banner');
                    setTimeout(() => {
                        ACTIVITY_DOM.updateActivityAlwaysDiscountDom();
                    }, 100);
                    break;
                case 6:
                    this.showYearReportPop = true;
                default:
                    break;
            }
        }
    }
}
</script>
